<template>
  <div class="skeleton-title loading my-2" :class="`w-${width ? width : 100}`"></div>
</template>

<script>
export default {
  name: "SkeletonTitle",
  props: {
    width: Number
  },
  data() {
    return {
      
    };
  },
  computed: {
 
  },
};
</script>

<style lang="css">
/* Card description */
.skeleton-title.loading {
  height: 1.5rem;
  width: 50%;
  border-radius: 3px;
}
/* The loading Class */
.loading {
  position: relative;
  background-color: #e2e2e2;
}

/* The moving element */
.loading::after {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateX(-100%);
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(transparent),
    color-stop(rgba(255, 255, 255, 0.2)),
    to(transparent)
  );

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );

  /* Adding animation */
  animation: loading 1.1s infinite;
}

/* Loading Animation */
@keyframes loading {
  100% {
    transform: translateX(100%);
  }
}
</style>